// These colors are taken from theme.palette.specialColors
export const appBgColorByProtocol = {
  http: 6,
  rdp: 7,
  https: 9,
  ssh: 3,
  vnc: 13
};

enum Categories {
  ACCOUNT = 'account',
  USER = 'user',
  NETWORK = 'network',
  GATEWAY = 'gateway',
  APPLICATION = 'application'
}

export const globalSearchCategories = [
  { name: 'Account', value: Categories.ACCOUNT, selected: true },
  { name: 'User', value: Categories.USER, selected: false },
  { name: 'Network', value: Categories.NETWORK, selected: false },
  { name: 'Gateway', value: Categories.GATEWAY, selected: false },
  { name: 'Application', value: Categories.APPLICATION, selected: false }
];

export const handleSetSearchPlaceholder = (selectedCategory: string) => {
  switch (selectedCategory) {
    case Categories.GATEWAY:
      return 'Search by name / ID / IP';
    case Categories.ACCOUNT:
    case Categories.NETWORK:
    case Categories.APPLICATION:
      return 'Search by name / ID';
    case Categories.USER:
      return 'Search by name / Email';
    default:
      return 'Search by';
  }
};

export const joinSubtitle = (items: string[]) => {
  const filteredItems = items.filter(item => item && item.trim() !== '');
  return filteredItems.length > 1
    ? filteredItems.join(' • ')
    : filteredItems[0];
};

export const mapUserData = (user: {
  firstName: string;
  lastName: string;
  dataResidency?: string;
  biDataResidency?: string;
  email: string;
  customerId: string;
}) => {
  const { firstName, lastName } = user;
  const notNA = (str: string) => str && str !== 'NA';
  return {
    name:
      notNA(firstName) && notNA(lastName)
        ? `${user.firstName} ${user.lastName}`
        : user.email,
    subtitle: joinSubtitle([
      user.email,
      user.customerId,
      user.dataResidency?.toUpperCase() ||
        user.biDataResidency?.toUpperCase() ||
        ''
    ]),
    customerId: user.customerId,
    region:
      user.biDataResidency?.toUpperCase() || user.dataResidency?.toUpperCase()
  };
};

export const mapNetworkData = (network: {
  networkName: string;
  networkId: string;
  customerId: string;
  dataResidency?: string;
  biDataResidency?: string;
}) => {
  return {
    name: network.networkName,
    subtitle: joinSubtitle([
      network.networkId,
      network.customerId,
      network.dataResidency?.toUpperCase() ||
        network.biDataResidency?.toUpperCase() ||
        ''
    ]),
    customerId: network.customerId,
    region:
      network.biDataResidency?.toUpperCase() ||
      network.dataResidency?.toUpperCase()
  };
};

export const mapAccountData = (account: {
  companyName: string;
  customerId: string;
  dataResidency?: string;
  biDataResidency?: string;
}) => {
  return {
    name: account.companyName || 'NA',
    subtitle: joinSubtitle([
      account.customerId,
      account.biDataResidency?.toUpperCase() ||
        account.dataResidency?.toUpperCase() ||
        ''
    ]),
    customerId: account.customerId,
    region:
      account.biDataResidency?.toUpperCase() ||
      account.dataResidency?.toUpperCase()
  };
};

export const mapGatewayData = (gateway: {
  gatewayId: string;
  gatewayIp: string;
  networkId: string;
  customerId: string;
  dataResidency?: string;
  biDataResidency?: string;
}) => {
  return {
    name: gateway.gatewayId,
    subtitle: joinSubtitle([
      gateway.gatewayIp,
      gateway.networkId,
      gateway.customerId
    ]),
    customerId: gateway.customerId,
    region:
      gateway.biDataResidency?.toUpperCase() ||
      gateway.dataResidency?.toUpperCase()
  };
};

export const mapApplicationData = (application: {
  appName: string;
  appId: string;
  customerId: string;
  dataResidency?: string;
  biDataResidency?: string;
}) => {
  return {
    name: application.appName,
    subtitle: joinSubtitle([application.customerId, application.appId]),
    customerId: application.customerId,
    region:
      application.biDataResidency?.toUpperCase() ||
      application.dataResidency?.toUpperCase()
  };
};
